import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from "vue";
import { API_BIS_PATENT_CLEAN, API_BIS_PATENT_CLEANDATALIST } from "@/configs/Apis";
import { showConfirm, showSuccess, showWarning } from "@/utils/UI";
import DuduAjax from "@/utils/DuduAjax";
import { useStore } from "@/stores";


export default /*#__PURE__*/_defineComponent({
  __name: 'DataClean',
  emits: ["data-changed"],
  setup(__props, { expose, emit }) {



const store = useStore();

const projectId = computed(() => {
  const pInfo: any = (store.state as any).project.info || {};
  return pInfo.id || 0;
});

const visible = ref(false);

const dataTable = ref<any>(null);

const changed = ref(false);

const selectedItems = ref<Array<any>>([]);

const dataItems = ref<Array<{ name: string }>>([]);

const condition = ref<any>({
  textField: "applicant",
  cleanValue: "",
  keyWord: "",
});

const recordCount = ref(0);

const pageSize = ref(20);

const pageIndex = ref(0);

const textFields = [
  { name: "applicant", label: "申请人" },
  { name: "inventor", label: "发明人" },
];

const colLabel = computed(() => {
  return textFields.find((item) => item.name === condition.value.textField)?.label || "";
});

const loadCleanDataList = () => {
  const queryParams = {
    fieldName: condition.value.textField,
    page: pageIndex.value - 1,
    pageSize: pageSize.value,
    keyWord: condition.value.keyWord,
  };
  DuduAjax.post<{ count: number; data: Array<any> }>(
    { url: API_BIS_PATENT_CLEANDATALIST, path: { projectId: projectId.value } },
    queryParams
  ).then((entity) => {
    recordCount.value = entity.count;
    dataItems.value = (entity.data || []).map((item) =>
      Object.assign(item, { rowKey: item.name + item.newName + item.count })
    );
  });
};

const doCleanData = () => {
  if (!selectedItems.value || !selectedItems.value.length) {
    showWarning("请选择要修改的数据项");
    return;
  }

  showConfirm("是否修改选中的数据").then(() => {
    DuduAjax.post(
      { url: API_BIS_PATENT_CLEAN, path: { projectId: projectId.value } },
      {
        fieldName: condition.value.textField,
        newValue: condition.value.cleanValue,
        oldValue: selectedItems.value.map((item) => item.name),
      }
    ).then(() => {
      showSuccess("保存成功");
      loadCleanDataList();
      changed.value = true;
      (dataTable.value as any).clearSelection();
    });
  });
};

const closeDialog = () => {
  visible.value = false;
  if (changed.value) {
    emit("data-changed");
  }
};

const open = () => {
  changed.value = false;
  selectedItems.value = [];
  visible.value = true;
  loadCleanDataList();
};

expose({ open });

const onSelectionChange = (items: Array<any>) => {
  selectedItems.value = items;
};

const onKeyWordChanged = () => {
  if (pageIndex.value === 1) {
    loadCleanDataList();
  } else {
    pageIndex.value = 1;
  }
};

const onFieldNameChange = () => {
  selectedItems.value = [];
  (dataTable.value as any).clearSelection();
  onKeyWordChanged();
};

watch(pageIndex, () => {
  loadCleanDataList();
});

watch(pageSize, () => {
  onKeyWordChanged();
});

return { __sfc: true,emit, store, projectId, visible, dataTable, changed, selectedItems, dataItems, condition, recordCount, pageSize, pageIndex, textFields, colLabel, loadCleanDataList, doCleanData, closeDialog, open, onSelectionChange, onKeyWordChanged, onFieldNameChange }
}

})